import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { AppComponent } from './app.component';
import { AppRoutes } from './app.routes';
import { OAuthModule } from 'angular-oauth2-oidc';
import * as COMPONENTS from './components';
import * as DIRECTIVES from './directives';
import * as SERVICES from './services';
import * as VIEWS from './views';
import * as SHAREDDATA from 'src/app/shared-data';
import { MaterialModule } from './material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [
    AppComponent,
    VIEWS.HomeViewV2Component,
    VIEWS.CheckoutViewV2Component,
    VIEWS.CreateCheckoutViewComponent,
    VIEWS.CompleteViewV2Component,
    VIEWS.ErrorViewComponent,
    VIEWS.ErrorUnavailableViewComponent,
    VIEWS.PendingComponent,
    VIEWS.AuthLoginViewComponent,
    VIEWS.AuthCallbackViewComponent,
    VIEWS.MobileSSOViewComponent,
    VIEWS.MobileSSOStartViewComponent,
    COMPONENTS.GiftCardComponent,
    COMPONENTS.GiftCardListComponent,
    COMPONENTS.HeaderComponent,
    COMPONENTS.SectionContentComponent,
    COMPONENTS.FooterComponent,
    COMPONENTS.MobileFooterComponent,
    COMPONENTS.LoaderComponent,
    COMPONENTS.LoaderInnerComponent,
    COMPONENTS.NewDesignVariantV2Component,
    COMPONENTS.SelectOptionV2Component,
    COMPONENTS.SpinnerComponent,
    COMPONENTS.BuyForFriendV2Component,
    COMPONENTS.GiphyComponent,
    COMPONENTS.GiftCardCategoryV2Component,
    COMPONENTS.CountrySwitcherComponent,
    COMPONENTS.SlideMenuComponent,
    COMPONENTS.DatePickerComponent,
    COMPONENTS.FooterMenuComponent,
    COMPONENTS.FooterItemComponent,
    COMPONENTS.HeaderMenuComponent,
    COMPONENTS.HeaderItemComponent,
    COMPONENTS.StepHeaderComponent,
    COMPONENTS.StepHeaderStepComponent,
    DIRECTIVES.RouterBackDirective,
    DIRECTIVES.OnlyNumber,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    AppRoutes,
    MaterialModule,
    OAuthModule.forRoot(),
  ],
  providers: [
    SERVICES.GiftCardsV2Service,
    SERVICES.ShopCentralService,
    SERVICES.CheckoutV2Service,
    SERVICES.LoaderService,
    CookieService,
    SHAREDDATA.SelectOptionService,
    SHAREDDATA.SelectOptionV2Service,
    SHAREDDATA.GiftcardCategoryV2Service,
    SHAREDDATA.GiftcardCategoryService,
    SHAREDDATA.GiftcardCategoryV2Service,
    SHAREDDATA.CheckoutStateService,
    SERVICES.ValidationService,
    SERVICES.GiphyService,
    SERVICES.AuthService,
    SERVICES.Auth0Service,
    SERVICES.IDS4Service,
    SERVICES.AuthGuardService,
    SERVICES.ThanksScriptService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SERVICES.AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SERVICES.UnauthorizedErrorInterceptor,
      multi: true,
    },
    SERVICES.TrxService,
    SERVICES.MarkdownService,
    SERVICES.MobileSSOService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
